import styled, { css } from 'styled-components';
import { IconCheck } from '@prisjakt/ui/icon/check';

export const SIZE = 20;

export const hoverStyle = css`
  box-shadow: inset 0 0 0 2px ${props => props.theme.bg.productCompare};
`;

type WrapperProps = {
  selected?: boolean;
};

export const Wrapper = styled.label.attrs({ 'data-test': 'ProductCheckbox' })<
  WrapperProps
>`
  display: flex;
  align-items: center;
  align-self: center;
  background: ${props =>
    props.selected ? props.theme.bg.productCompare : 'transparent'};
  box-shadow: inset 0 0 0 1px ${props => props.theme.bg.productCompare};
  color: ${props => props.theme.colors.base0};
  border-radius: 3px;
  cursor: pointer;
  height: ${SIZE}px;
  width: ${SIZE}px;
  flex: 0 0 auto;
  transition: 0.05s box-shadow linear, 0.05s background-color linear;

  &:hover {
    ${hoverStyle}
  }
`;

export const Input = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  outline: 0;
  opacity: 0;
  position: absolute;
`;

export const Icon = styled(IconCheck).attrs({ size: SIZE })``;
